import { useCallback, useRef, useState, useEffect } from 'react';
export const useHoverIntent = ({
  timeout = 500,
  submenuElementQuery,
  triggerElementQuery
}) => {
  const [isHoveredWithIntent, setIsHoveredWithIntent] = useState(false);
  const [isHoverEnabled, setIsHoverEnabled] = useState(true);
  const timeoutRef = useRef();
  const mousePositionRef = useRef();
  const clearTimeouts = useCallback(() => {
    if (timeoutRef.current) {
      window.clearTimeout(timeoutRef.current);
      timeoutRef.current = undefined;
    }
  }, []);
  useEffect(() => {
    const updateMousePosition = e => {
      mousePositionRef.current = {
        x: e.clientX,
        y: e.clientY
      };
      setIsHoverEnabled(true);
    };
    document.addEventListener('mousemove', updateMousePosition);
    return () => document.removeEventListener('mousemove', updateMousePosition);
  }, []);
  const isMouseInElement = useCallback(element => {
    if (!element || !mousePositionRef.current) return false;
    const rect = element.getBoundingClientRect();
    const {
      x: mouseX,
      y: mouseY
    } = mousePositionRef.current;
    return mouseX <= rect.right && mouseX >= rect.left && mouseY <= rect.bottom && mouseY >= rect.top;
  }, []);
  const handleMouseEnter = useCallback(() => {
    if (!isHoverEnabled) return;
    clearTimeouts();
    setIsHoveredWithIntent(true);
  }, [clearTimeouts, isHoverEnabled]);
  const handleMouseLeave = useCallback(() => {
    if (!isHoverEnabled) return;
    clearTimeouts();
    timeoutRef.current = window.setTimeout(() => {
      const submenuElement = document.querySelector(submenuElementQuery);
      const triggerElement = triggerElementQuery ? document.querySelector(triggerElementQuery) : null;
      if (!isMouseInElement(submenuElement) && (!triggerElement || !isMouseInElement(triggerElement))) {
        setIsHoveredWithIntent(false);
      }
    }, timeout);
  }, [clearTimeouts, timeout, isHoverEnabled, isMouseInElement, submenuElementQuery, triggerElementQuery]);
  const disableHoverUntilMouseMove = useCallback(() => {
    setIsHoverEnabled(false);
    setIsHoveredWithIntent(false);
  }, []);
  useEffect(() => {
    return () => {
      clearTimeouts();
    };
  }, [clearTimeouts]);
  return {
    isHoveredWithIntent: isHoverEnabled && isHoveredWithIntent,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    disableHoverUntilMouseMove
  };
};